// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2sPp4","delete":"styles_delete__yuqsw","update":"styles_update__2-Ug_","add":"styles_add__PWLiI"};